<template>
  <div class="home-carousel">
    <div id="carouselExampleIndicatorsMobile" class="carousel slide" data-ride="carousel" data-interval="3000" data-pause="false">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="6"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active" @click="toCompanyIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_index.jpg" alt="First slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWstudioIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_1.jpg" alt="Second slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title6") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle6") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toIntelliMatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_8.jpg" alt="Third slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title1") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle1") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toQStudioAIIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_9.jpg" alt="Fourth slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title2") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle2") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toMLFFIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_4.png" alt="Fifth slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title3") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle3") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toQstationIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_7.png" alt="Sixth slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title4") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle4") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toFeaturedCapabilities">
          <img class="d-block w-100" src="../../assets/home/banner_new_2.png" alt="Seventh slide">
          <div class="home-carousel-caption d-block">
            <div class="home-carousel-title">{{ $t("carousel.title5") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle5") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: "HomeCarouselMobile",
    mounted() {
      this.$nextTick(() => {
        $('#carouselExampleIndicatorsMobile').carousel({
          interval: 3000,
          pause: false,
        })
      })
    },
    methods: {
      toPWmatIntroduce() {
        this.$router.push({ name: 'PWmatIntroduce' })
      },
      toPWstudioIntroduce() {
        this.$router.push({ name: 'PWstudioIntroduce' })
      },
      toFeaturedCapabilities() {
        this.$router.push({ name: 'FeaturedCapabilities' })
        $('.collapse').collapse('hide')
      },
      toMLFFIntroduce() {
        this.$router.push({ name: 'MLFFIntroduce' })
      },
      toQstationIntroduce() {
        this.$router.push({ name: 'Integration' })
      },
      toIntelliMatIntroduce() {
        this.$router.push({ name: 'IntelliMatIntroduce' })
      },
      toQStudioAIIntroduce() {
        this.$router.push({ name: 'QStudioAIIntroduce' })
      },
      toCompanyIntroduce() {
        this.$router.push({ name: 'CompanyIntroduce' })
        $('.collapse').collapse('hide')
      },
    },
  }
</script>

<style scoped>
  .home-carousel{
    margin-top: 70px;
  }
  .home-carousel-caption {
    position: absolute;
    right: 15%;
    top: 20%;
    left: 15%;
    z-index: 10;
    color: #fff;
    text-align: center;
    display: block;
  }
  .home-carousel-title{
    font-size: 48px;
    font-family:PingFangSC-Semibold,sans-serif
  }
  .home-carouse-content{
    font-size: 22px;
    font-family: PingFangSC-Light,sans-serif;
    margin-top: 16px;
  }
  .home-carouse-button{
    border: 2px solid #ffffff;
    background-color: rgb(255,255,255,0.2) ;
    margin-top: 50px;
    width: 340px;
    height: 55px;
    cursor: pointer;
  }
  .home-carouse-button:hover,
  .home-carouse-button:active,
  .home-carouse-button:focus{
    box-shadow:none !important;
    outline:none !important;
  }
  .home-carouse-button-text{
    color: #ffffff;
    font-family: PingFangSC-Light,sans-serif;
    font-size: 24px;
  }
  .carousel-item{
    cursor: pointer;
  }
  .carouse-inner-mobile{
    display: none;
  }

  @media (max-width: 470px) {

    .home-carousel-title{
      font-size: 18px;
    }
    .home-carouse-content{
      font-size: 12px;
      margin-top: 8px;
      max-height: 2.8em;
      overflow: hidden;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
    .carousel-indicators {
      bottom: 0;
    }
    .carousel-item{
      height: 52vw;
      min-height: 160px;
    }
    .carousel-item img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .home-carousel-caption{
      left: 8%;
      right: 8%;
      top: 16%;
    }
  }

  @media (min-width: 470px) and  (max-width: 576px) {

    .home-carousel-title{
      font-size: 24px;
    }
    .home-carouse-content{
      font-size: 14px;
      margin-top: 10px;
      max-height: 2.8em;
      overflow: hidden;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
    .carousel-item{
      height: 52vw;
    }
    .carousel-item img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .home-carousel-caption{
      left: 8%;
      right: 8%;
      top: 16%;
    }
  }

  @media (min-width: 576px) and  (max-width: 768px) {

    .home-carousel-title{
      font-size: 32px;
    }
    .home-carouse-content{
      font-size: 16px;
      max-height: 2.8em;
      overflow: hidden;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
    .carousel-item{
      height: 40vw;
    }
    .carousel-item img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (min-width: 768px) and  (max-width: 900px) {

    .home-carousel-title{
      font-size: 34px;
    }
    .home-carouse-content{
      font-size: 16px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 900px) and (max-width: 1150px) {

    .home-carousel-title{
      font-size: 40px;
    }
    .home-carouse-content{
      font-size: 18px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1150px) and (max-width: 1440px) {

    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1440px) {

  }
</style>